import { render, staticRenderFns } from "./component-catalogo-form.vue?vue&type=template&id=125b041e&"
import script from "./component-catalogo-form.vue?vue&type=script&lang=js&"
export * from "./component-catalogo-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/administracion-frontend/administracion-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125b041e')) {
      api.createRecord('125b041e', component.options)
    } else {
      api.reload('125b041e', component.options)
    }
    module.hot.accept("./component-catalogo-form.vue?vue&type=template&id=125b041e&", function () {
      api.rerender('125b041e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-catalogo/component-catalogo-form/component-catalogo-form.vue"
export default component.exports